import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["scheme", "sx", "children"];
import React from 'react';
import Box from './Box.js';
import './sx.js';
import VisuallyHidden from './_VisuallyHidden.js';
import merge from 'deepmerge';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CounterLabel = function CounterLabel(_ref) {
  var _ref$scheme = _ref.scheme,
    scheme = _ref$scheme === void 0 ? 'secondary' : _ref$scheme,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({
    as: "span",
    "aria-hidden": "true",
    sx: merge({
      display: 'inline-block',
      padding: '2px 5px',
      fontSize: 0,
      fontWeight: 'bold',
      lineHeight: 'condensedUltra',
      borderRadius: '20px',
      backgroundColor: scheme === 'primary' ? 'neutral.emphasis' : 'neutral.muted',
      color: scheme === 'primary' ? 'fg.onEmphasis' : 'fg.default',
      '&:empty': {
        display: 'none'
      }
    }, sx)
  }, props), children), /*#__PURE__*/React.createElement(VisuallyHidden, null, "\xA0", "(".concat(children, ")")));
};
CounterLabel.displayName = 'CounterLabel';
var CounterLabel$1 = CounterLabel;
export { CounterLabel$1 as default };